/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class EditTemplateNameRequest {
    getFixupPrototypeFunction() { return EditTemplateNameRequest.fixupPrototype; }

    static newInstance(model: Partial<EditTemplateNameRequest>): EditTemplateNameRequest {
        let obj = Object.assign(new EditTemplateNameRequest(), model);
        EditTemplateNameRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<EditTemplateNameRequest>): EditTemplateNameRequest {
        if (!model) return null;
        return EditTemplateNameRequest.newInstance(<EditTemplateNameRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: EditTemplateNameRequest) {
        if (!obj) return;

        models.EditTemplateNameRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: EditTemplateNameRequest): boolean {
        Object.setPrototypeOf(obj, EditTemplateNameRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Provide the name for the template to be updated
     */
    name: string;

}
